// Helper to wait for a node to appear
async function waitForElm(selector) {
  if (document.querySelector(selector)) {
    return document.querySelector(selector);
  }

  return new Promise((resolve) => {
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

class DrawerFooterCarousel {
  constructor() {
    this.init();
  }

  async injectStyles(shadowRoot) {
    try {
      // Fetch and inject Swiper CSS
      const swiperResponse = await fetch(
        "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
      );
      const swiperCss = await swiperResponse.text();

      // Fetch and inject our custom CSS
      const customResponse = await fetch(
        window.themeVariables.drawerFooterCarouselCss
      );
      const customCss = await customResponse.text();

      // Combine both CSS contents
      const styleElement = document.createElement("style");
      styleElement.textContent = swiperCss + "\n" + customCss;

      const headerPart = shadowRoot.querySelector('header[part="header"]');
      if (headerPart) {
        headerPart.appendChild(styleElement);
      }
    } catch (error) {
      console.error("Failed to inject styles:", error);
    }
  }

  async addToCart(variantId, button, slideIndex) {
    try {
      // Disable button and show loading state
      button.disabled = true;
      button.style.opacity = "0.7";
      button.style.cursor = "not-allowed";

      // Add to cart
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) throw new Error("Failed to add to cart");

      // Update button state
      button.innerHTML = "Added to cart";
      button.style.backgroundColor = "#686846";
      button.style.color = "white";
      button.style.border = "none";

      // Get the cart drawer and its shadow root
      const cartDrawer = document.querySelector("#cart-drawer");
      if (!cartDrawer) return;

      // Get the cart items container
      const cartItemsContainer = document.querySelector(
        "#cart-drawer .cart-drawer__items"
      );
      if (!cartItemsContainer) return;

      // Get the product title from the button's parent element
      const productTitle = button
        .closest(".swiper-product-card")
        .querySelector("h3")
        .textContent.trim();

      // Check if item already exists in cart
      const existingItem = Array.from(
        cartItemsContainer.querySelectorAll("line-item")
      ).find((item) => {
        const itemTitle = item.querySelector(".h6").textContent.trim();
        return itemTitle === productTitle;
      });
      console.log({ existingItem });

      if (existingItem) {
        // Update quantity if item exists
        const quantityInput = existingItem.querySelector(
          ".quantity-selector__input"
        );
        console.log({ quantityInput });

        if (quantityInput) {
          const currentQuantity = parseInt(quantityInput.value);
          quantityInput.value = currentQuantity + 1;

          // Update the cart using the variantId from the button
          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: currentQuantity + 1,
            }),
          });
          console.log("updated quantity");
        }
      } else {
        // Add new item to cart
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        console.log({ cartData });

        // Find the newly added item by title
        const newItem = cartData.items.find(
          (item) => item.title === productTitle
        );
        if (newItem) {
          const lineItem = document.createElement("line-item");
          lineItem.className = "line-item";
          lineItem.dataset.slideIndex = slideIndex;

          lineItem.innerHTML = `
            <img src="${newItem.image}" alt="${
            newItem.title
          }" class="line-item__media">
            <div class="line-item-info w-full h-full">
              <div class="line-item-info-head">
                <div class="h-stack gap-6 justify-between">
                  <a href="/products/${newItem.handle}?variant=${
            newItem.variant_id
          }" class="h6">${newItem.title}</a>
                  <price-list class="price-list">
                    <sale-price class="h6 text-subdued">
                      <span class="sr-only">Sale price</span>$${
                        newItem.price / 100
                      }</sale-price>
                  </price-list>
                </div>
                <line-item-quantity class="h-stack gap-4 justify-between">
                  <quantity-selector class="quantity-selector quantity-selector--sm">
                    <a href="/cart/change?id=${newItem.variant_id}&quantity=${
            newItem.quantity - 1
          }" class="quantity-selector__button">
                      <span class="sr-only">Decrease quantity</span>
                      <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
                        <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                      </svg>
                    </a>
                    <quantity-input class="quantity-selector__input-wrapper" style="--quantity-selector-character-count: 1ch;">
                      <input class="quantity-selector__input text-sm" type="number" value="${
                        newItem.quantity
                      }" name="updates[]" inputmode="numeric" step="1" min="1" data-line-key="${
            newItem.variant_id
          }" aria-label="Change quantity">
                    </quantity-input>
                    <a href="/cart/change?id=${newItem.variant_id}&quantity=${
            newItem.quantity + 1
          }" class="quantity-selector__button">
                      <span class="sr-only">Increase quantity</span>
                      <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
                        <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                      </svg>
                    </a>
                  </quantity-selector>
                  <a href="/cart/change?id=${
                    newItem.variant_id
                  }&quantity=0" class="link text-xs remove-item" aria-label="Remove ${
            newItem.title
          }">Remove</a>
                </line-item-quantity>
              </div>
            </div>
          `;

          cartItemsContainer.appendChild(lineItem);

          // Add event listener for remove button
          const removeButton = lineItem.querySelector(".remove-item");
          if (removeButton) {
            removeButton.addEventListener("click", async (e) => {
              e.preventDefault();
              await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  id: newItem.variant_id,
                  quantity: 0,
                }),
              });
              lineItem.remove();
              this.updateCheckoutButtonPrice();

              // Reset the carousel button state for this variant and slide index
              const cartDrawer = document.querySelector("#cart-drawer");
              const shadowRoot = cartDrawer ? cartDrawer.shadowRoot : null;
              const carouselButton = shadowRoot
                ? shadowRoot.querySelector(
                    `.add-to-cart[data-variant-id="${newItem.variant_id}"][data-slide-index="${lineItem.dataset.slideIndex}"]`
                  )
                : null;
              if (carouselButton) {
                carouselButton.disabled = false;
                carouselButton.innerHTML = `ADD TO CART <span class="separator">•</span> $${(
                  newItem.price / 100
                ).toFixed(2)}`;
                carouselButton.style.backgroundColor = "white";
                carouselButton.style.color = "rgb(104, 106, 70)";
                carouselButton.style.border = "1px solid rgb(104, 106, 70)";
                carouselButton.style.cursor = "pointer";
                carouselButton.style.opacity = "1";
              }
            });
          }
        }
      }

      // Update checkout button price after any cart changes
      await this.updateCheckoutButtonPrice();
    } catch (error) {
      console.error("Error adding to cart:", error);
      // Reset button state on error
      button.disabled = false;
      button.style.opacity = "1";
      button.style.cursor = "pointer";
    }
  }

  async updateCheckoutButtonPrice() {
    console.log("updateCheckoutButtonPrice");
    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      console.log({ cartData });

      const checkoutButton = document.querySelector(
        '#cart-drawer button[name="checkout"]'
      );
      if (checkoutButton) {
        const priceSpan = checkoutButton.querySelector(
          ".cart-drawer__button-price"
        );
        console.log({ priceSpan });

        if (priceSpan) {
          priceSpan.textContent = `$${(cartData.total_price / 100).toFixed(2)}`;
        }
      }
    } catch (error) {
      console.error("Error updating checkout button price:", error);
    }
  }

  setupCartButtons(shadowRoot) {
    const buttons = shadowRoot.querySelectorAll(".add-to-cart");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = button.dataset.variantId;
        const slideIndex = button.dataset.slideIndex;
        if (variantId) {
          this.addToCart(variantId, button, slideIndex);
        }
      });
    });
  }

  async init() {
    // Get the cart drawer and its shadow root
    console.log("init");
    const cartDrawer = document.querySelector("#cart-drawer");
    if (!cartDrawer) return;
    console.log("cart", cartDrawer);
    const shadowRoot = cartDrawer.shadowRoot;
    if (!shadowRoot) return;

    // Find the carousel content inside shadow DOM
    const carouselContent = shadowRoot.querySelector(
      ".drawer-footer-carousel-content"
    );
    if (!carouselContent) return;

    // Create swiper container and wrapper
    carouselContent.innerHTML = `
      <div class="swiper drawer-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper-product-card" style="max-height: 200px; overflow: hidden;">
              <div style="display: flex; gap: 8px; margin-bottom: 12px; height: 100px;">
                <img src="https://cdn.shopify.com/s/files/1/0583/9283/8321/files/soy-candle.png?v=1745921526" alt="Love You Fluted Soy Candle" style="height: 100%; width: auto; object-fit: contain;">
                <h3 style="font-family: Literata, sans-serif; font-size: 14px; line-height: 24px; margin: 0; font-weight: 400; overflow: hidden; text-overflow: ellipsis;">Love You Fluted Soy Candle - Ribbed Glass Jar</h3>
              </div>
              <button class="add-to-cart" data-variant-id="43986592170161" data-slide-index="0" style="cursor: pointer; background: none; border: 1px solid rgb(104, 106, 70); display: flex; gap: 8px; align-items: center; font-family: Literata, sans-serif; font-size: 14px; color: rgb(104, 106, 70); padding: 10px; width: 100%; justify-content: center;">ADD TO CART <span class="separator">•</span> $29.99</button>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-product-card" style="max-height: 200px; overflow: hidden;">
              <div style="display: flex; gap: 8px; margin-bottom: 12px; height: 100px;">
                <img src="https://cdn.shopify.com/s/files/1/0583/9283/8321/files/bear.png?v=1745921526" alt="Classic Cuddly Teddy Bear" style="height: 100%; width: auto; object-fit: contain;">
                <h3 style="font-family: Literata, sans-serif; font-size: 14px; line-height: 24px; margin: 0; font-weight: 400; overflow: hidden; text-overflow: ellipsis;">Classic Cuddly Teddy Bear</h3>
              </div>
              <button class="add-to-cart" data-variant-id="45083198619825" data-slide-index="1" style="cursor: pointer; background: none; border: 1px solid rgb(104, 106, 70); display: flex; gap: 8px; align-items: center; font-family: Literata, sans-serif; font-size: 14px; color: rgb(104, 106, 70); padding: 10px; width: 100%; justify-content: center;">ADD TO CART <span class="separator">•</span> $36.99</button>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-product-card" style="max-height: 200px; overflow: hidden;">
              <div style="display: flex; gap: 8px; margin-bottom: 12px; height: 100px;">
                <img src="https://cdn.shopify.com/s/files/1/0583/9283/8321/files/soy-candle.png?v=1745921526" alt="Love You Fluted Soy Candle" style="height: 100%; width: auto; object-fit: contain;">
                <h3 style="font-family: Literata, sans-serif; font-size: 14px; line-height: 24px; margin: 0; font-weight: 400; overflow: hidden; text-overflow: ellipsis;">Love You Fluted Soy Candle - Ribbed Glass Jar</h3>
              </div>
              <button class="add-to-cart" data-variant-id="43986592170161" data-slide-index="2" style="cursor: pointer; background: none; border: 1px solid rgb(104, 106, 70); display: flex; gap: 8px; align-items: center; font-family: Literata, sans-serif; font-size: 14px; color: rgb(104, 106, 70); padding: 10px; width: 100%; justify-content: center;">ADD TO CART <span class="separator">•</span> $29.99</button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Setup cart functionality
    this.setupCartButtons(shadowRoot);

    // Initialize Swiper
    const swiper = new Swiper(shadowRoot.querySelector(".drawer-swiper"), {
      slidesPerView: 2.2,
      spaceBetween: 20,
      navigation: {
        nextEl: shadowRoot.querySelector(".carousel-nav-btn-next"),
        prevEl: shadowRoot.querySelector(".carousel-nav-btn-prev"),
      },
    });

    // Inject styles into shadow root
    await this.injectStyles(shadowRoot);
  }
}

// Initialize the carousel when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new DrawerFooterCarousel();
});

// Also initialize when drawer content changes (for dynamic loading)
document.addEventListener("drawer:content:changed", (e) => {
  new DrawerFooterCarousel();
});

// Observe #cart-drawer display property and hide .gt_float_switcher when open
(function observeCartDrawerDisplay() {
  // Helper to wait for a node to appear
  function waitForElement(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          observer.disconnect();
          resolve(el);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  Promise.all([
    waitForElement("#cart-drawer"),
    waitForElement(".gt_float_switcher"),
  ]).then(([cartDrawer, floatSwitcher]) => {
    const checkAndToggle = () => {
      const display = getComputedStyle(cartDrawer).display;
      if (display === "block") {
        floatSwitcher.style.display = "none";
      } else {
        floatSwitcher.style.display = "";
      }
    };

    // Initial check
    checkAndToggle();

    const observer = new MutationObserver(() => {
      checkAndToggle();
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["style"],
    });
  });
})();
